import { Segmented } from "antd";

const MySegmented = ({
  options,
  value,
  className,
  size = "large",
  onChange,
}) => {
  return (
    <Segmented
      options={options}
      value={value}
      onChange={onChange}
      className={`${className}`}
      size={size}
    />
  );
};

export default MySegmented;
